import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const ChangePassword = lazy(() => import(/* webpackChunkName: 'change-password' */ './containers/changePassword'))

const initRoute = () => {
    registerRoute({ path: routes.CHANGE_PASSWORD, element: createElement(ChangePassword) })
}

export default initRoute
